const init = () => {
	const slider = document.querySelector('.index__slider');

	new Swiper(slider, {
		loop: true,
		speed: 2000,
		grabCursor: true,
		autoplay: {
			delay: 3500,
			disableOnInteraction: false,
		},
		watchSlidesProgress: true,
		mousewheelControl: true,
		keyboardControl: true,
		parallax:true,
		pagination: {
			el: ".swiper-pagination",

		},
	});
};

export default {
	init
};
